import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import moment from 'moment';
import {withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {dmsPurchaseList, getCustomerNoInvoice} from '../../service/reportForm';
import {fetchChannelList} from '../../service/home';

class CustomerNoInvoice extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            opts: ['客户未开票明细表'],
            channelCode: this.channelId,
            key: 0,
            id: '',
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dataSource: [],
            detailTotal: 1,
            channel_type: [],
            gouxiaoUnitList: [],
            searchObj: {
                salesChannelCode: '',
                s: 10,
                p: 1,
                startDate: '',
                endDate: '',
                salesUnitId: ''
            },
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goAdd() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/customerInvoice/noInvoiceExportExcel`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                s: 10,
                p: 1,
                startDate: '',
                endDate: '',
                salesUnitId: '',
                salesChannelCode: '',
            }, loading: false
        }, function () {
            //self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.startDate || this.state.searchObj.startDate == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.endDate || this.state.searchObj.endDate == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {

            /* if (self.state.searchObj.salesUnitId == '') {
                 openNotice('warning', '请确定购货单位');
                 return
             }*/
            self.initData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({searchObj: {...this.state.searchObj, startDate: value.from, endDate: value.end}})
        } else {
            if (value == 'ALL') {
                this.setState({searchObj: {...this.state.searchObj, [name]: ''}})
            } else {
                this.setState({searchObj: {...this.state.searchObj, [name]: value}})
            }
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    initData() {
        let searchObj = this.state.searchObj;
        let self = this;
        getCustomerNoInvoice(searchObj).then((result) => { //数据详情
            this.setState({
                'dataSource': result.data || [],
                'detailTotal': result.total || 1,
                loading: false
            });
        });
    }

    componentDidMount() {
        let self = this;
        dmsPurchaseList({channelCode: this.state.channelCode, p: 1, s: 100}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        //this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            opts,
            key,
            dataSource,
            detailTotal,
            searchObj,
            gouxiaoUnitList,
            channel_type,
            loading
        } = this.state;
        const filterBoxProps = {
            fileds: [

                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '请选择',
                    type: 'select',
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                }, {
                    name: 'date',
                    label: '出库日期',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startDate || '',
                        end: searchObj.endDate || ''
                    }
                }, {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: false
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };

        const tableViewProps2 = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total: detailTotal,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '购货单位',
                    dataIndex: 'salesUnitName',
                }, {
                    title: '渠道',
                    dataIndex: 'salesChannel',
                }, {
                    title: '出库单号',
                    dataIndex: 'deliveryId',
                }, {
                    title: '出库日期',
                    dataIndex: 'crDate',
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : '----'
                }, {
                    title: '订单号',
                    dataIndex: 'soNumber'
                }, {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc',
                }, {
                    title: '产品大类',
                    dataIndex: 'itemCategory',
                }, {
                    title: '出库单价',
                    dataIndex: 'sellingPrice'
                }, {
                    title: '出库数量',
                    dataIndex: 'orderQuantity',
                }, {
                    title: '未开数量',
                    dataIndex: 'quantity',
                }, {
                    title: '税码',
                    dataIndex: 'taxCode',
                }, {
                    title: '发票池ID',
                    dataIndex: 'lineId',
                }
            ],
            rows: dataSource
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goAdd.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps2} />
            </div>
        </div>
    }
}
;
export default withRouter(CustomerNoInvoice);


// WEBPACK FOOTER //
// ./src/routes/reportForm/customerNoInvoice.js